var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1261 16.5C33.1261 25.6127 25.7388 33 16.6261 33C7.5134 33 0.126099 25.6127 0.126099 16.5C0.126099 7.3873 7.5134 0 16.6261 0C25.7388 0 33.1261 7.3873 33.1261 16.5ZM11.4903 9.79552C11.4903 10.8227 10.7081 11.654 9.48503 11.654C8.30957 11.654 7.52744 10.8227 7.55165 9.79552C7.52744 8.7184 8.30955 7.91132 9.50846 7.91132C10.7081 7.91132 11.4668 8.7184 11.4903 9.79552ZM7.64998 25.0863V13.1222H11.3685V25.0863H7.64998ZM14.2506 13.1238C14.2998 14.176 14.3489 15.4482 14.3489 16.9406H14.3504V25.0886H18.069V18.1887C18.069 17.8453 18.1174 17.5034 18.2157 17.2583C18.46 16.5738 19.0712 15.8643 20.0991 15.8643C21.4448 15.8643 21.9826 16.9157 21.9826 18.458V25.0886H25.7011V17.992C25.7011 14.4702 23.8661 12.8553 21.4198 12.8553C19.438 12.8553 18.2149 14.0043 17.7255 14.7629H17.6522L17.4805 13.1238H14.2506Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/LinkedinIcon.d8090f18fa2e91f4d09f197b33453a7d.svg";
export { ForwardRef as ReactComponent };